import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./TagMenu.css";
import "../../css/Icons.css";

const TAG_MENU = {
  DELETE: "delete",
  RENAME: "rename",
};

type TagMenuProps = {
    tagId: string;
    onDelete: () => void;
    onRename: () => void;
};

export default function TagMenu({ 
    tagId,
    onDelete,
    onRename,
} : TagMenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();

  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // route it
    switch (selection) {
      case TAG_MENU.DELETE:
        onDelete();
        break;
      case TAG_MENU.RENAME:
        onRename();
        break;
      default:
    }
  };

  
  return (
    <>
      <div className="tag-menu" onClick={handleButtonClick}>
        <div className="tag-menu-image">
          <img className="icon-three-dots-vertical" alt="" />
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={(e: any) => {
          e.stopPropagation();
          handleMenuClose();
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        <MenuItem 
             onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                handleMenuSelection(TAG_MENU.RENAME)
            }}
        >
          Rename
        </MenuItem>

        <MenuItem 
             onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                handleMenuSelection(TAG_MENU.DELETE)
            }}
        >
          Delete
        </MenuItem>

      </Menu>
    </>
  );
}
